import Vue from 'vue'
import Vuex from 'vuex'
import loadingSpinner from './modules/loadingSpinner'
import alertTopBar from './modules/alertTopBar'
import VueCookie from 'vue-cookie';
import {HOST} from "@/main";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        loadingSpinner: loadingSpinner,
        alertTopBar: alertTopBar,
    },
    state: {
        // Account
        user: {},
        notifications: [],

        shoppingCart: null,
        csrf_token: null,
        authInitialized: false,
        authCheckPromise: null
    },
    getters: {
        isAdmin(state) {
            return state.user.type && state.user.type == 369;
        },
        hasModulePermission(state) {
            return function (module_key) {
                if (state.user.type && state.user.type == 369) {
                    return true
                }
                return state.user.permissions && _.filter(state.user.permissions, function (p) {
                    return p.startsWith(module_key);
                }).length > 0;
            }
        },
        hasPermission(state) {
            return function (key) {
                let module_key = key.split('.')[0];

                if (state.user.type && state.user.type == 369) {
                    return true
                }
                return state.user.permissions && (state.user.permissions.indexOf(module_key) !== -1 || state.user.permissions.indexOf(key) !== -1)
            }
        },
    },
    mutations: {
        signIn(state, user) {
            state.user = user;
        },
        signOut(state) {
            state.user = {};
        },
        setNotifications(state, notifications) {
            state.notifications = notifications;
        },
        setShoppingCart(state, booking_record) {
            state.shoppingCart = booking_record;
        },
        setCsrfToken(state, csrf_token) {
            state.csrf_token = csrf_token;
        },
        setAuthInitialized(state, value) {
            state.authInitialized = value;
        },
        setAuthCheckPromise(state, promise) {
            state.authCheckPromise = promise;
        },
    },
    actions: {
        async fetchCsrfToken({commit}) {
            try {
                const response = await Vue.http.get(HOST + 'csrf/');
                const token = response.body.csrf_token;
                if (token) {
                    commit('setCsrfToken', token);
                    return token;
                }
            } catch (error) {
                console.error('Failed to fetch CSRF token:', error);
                throw error;
            }
        },

        login({commit}, {v, username, password}) {
            v.$callAPI('login/', {
                username: username,
                company_domain: '.',
                password: password,
            }, function (response) {
                v.$storeDispatch('getMe');
            });
        },
        logout({commit}, {v}) {
            v.$callAPI('logout/', {}, function (response) {
                commit('signOut');
                commit('setCsrfToken', null);
                commit('setAuthInitialized', false);
                commit('setAuthCheckPromise', null);
            }, function (response) {
                console.error('LOG OUT FAILED');
                commit('signOut');
                commit('setCsrfToken', null);
                commit('setAuthInitialized', false);
                commit('setAuthCheckPromise', null);
            })
        },
        getMe({commit}, {v}) {
            v.$callAPI('hkiarace/me/', {}, function (response) {
                commit('signIn', response.body.user);
                v.$cookie.set('UID', response.body.user.id, {samesite: 'Strict', secure: true});
            }, function (response) {
                // v.$router.push({name: 'login'});
            });
        },
        getShoppingCart({commit}, {v}) {
            v.$callAPI('aafb/shopping_cart/', {}, function (response) {
                commit('setShoppingCart', response.body.booking_record);
            }, function (response) {
                // v.$router.push({name: 'login'});
            });
        },
        adminGetMe({commit}, {v}) {
            v.$callAPI('hkiarace/admin/me/', {}, function (response) {
                commit('signIn', response.body.admin);
                commit('setAuthInitialized', true);
            }, function (response) {
                commit('setAuthInitialized', true);
                // v.$router.push({name: 'login'});
            });
        },
        ensureAuthCheck({state, commit, dispatch}, {v}) {
            // If auth is already initialized, return resolved promise
            if (state.authInitialized) {
                return Promise.resolve();
            }
            
            // If auth check is already in progress, return existing promise
            if (state.authCheckPromise) {
                return state.authCheckPromise;
            }
            
            // Start new auth check
            const promise = new Promise((resolve) => {
                // Set a timeout to resolve anyway after 5 seconds
                const timeout = setTimeout(() => {
                    commit('setAuthInitialized', true);
                    commit('setAuthCheckPromise', null);
                    resolve();
                }, 5000);
                
                // Create or use existing Vue instance
                let vueInstance = v;
                if (!vueInstance) {
                    // Create a minimal Vue instance with necessary context for $callAPI
                    vueInstance = new Vue({
                        store: this,  // 'this' in action context is the store
                    });
                }
                
                vueInstance.$callAPI('hkiarace/admin/me/', {}, 
                    (response) => {
                        clearTimeout(timeout);
                        commit('signIn', response.body.admin);
                        commit('setAuthInitialized', true);
                        commit('setAuthCheckPromise', null);
                        resolve();
                    },
                    (err) => {
                        clearTimeout(timeout);
                        commit('setAuthInitialized', true);
                        commit('setAuthCheckPromise', null);
                        resolve();
                    },
                    true  // not_blocking - don't show loading spinner
                );
            });
            
            commit('setAuthCheckPromise', promise);
            return promise;
        },
        getNotifications({commit, state}, {v}) {
            if (state.user.id) {
                // v.$callAPI('notifications/', {}, function (response) {
                //     commit('setNotifications', response.body.notifications);
                // }, function (response) {
                //     console.log('getNotifications Failed');
                // }, true);
            }
        },
    }
})
